import {useStyles} from '@wix/tpa-settings/react'
import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {PROMOTIONAL_BADGE} from '../../../../../settings-commons/components/promotional-badges/interfaces'
import stylesParams from '../../../stylesParams'
import {useWidgetState} from '../../hooks/state-provider'
import {getPromotionalBadge} from '../../selectors/events'
import {PromotionalBadgeProps} from './interfaces'
import s from './promotional-badge.scss'

export const PromotionalBadge = ({event, onImage, className}: PromotionalBadgeProps) => {
  const {get} = useStyles()
  const {experiments} = useExperiments()

  const fullWidth = get(stylesParams.promotionalBadgeStretched)
  const promotionalBadge = useWidgetState(state => getPromotionalBadge(state, event))
  const label =
    promotionalBadge === PROMOTIONAL_BADGE.FIRST_PRIORITY
      ? 'First'
      : promotionalBadge === PROMOTIONAL_BADGE.SECOND_PRIORITY
      ? 'Second'
      : 'Third'

  return experiments.enabled(ExperimentNames.PromotionalBadges) && !!promotionalBadge ? (
    <div
      className={classNames(className, onImage ? s.onImage : s.eventInfo, {
        [s.container]: onImage,
        [s.second]: promotionalBadge === PROMOTIONAL_BADGE.SECOND_PRIORITY,
        [s.third]: promotionalBadge === PROMOTIONAL_BADGE.THIRD_PRIORITY,
      })}
    >
      <div data-hook="promotional-badge" className={classNames(s.badge, {[s.fullWidth]: onImage && fullWidth})}>
        <div>{label}</div>
      </div>
    </div>
  ) : null
}
